module.exports = __webpack_public_path__ + "static/media/f2.9b0d117c.jpg";